import { Textsms } from '@mui/icons-material'
import { Box, IconButton } from '@mui/material'

interface ToggleCommentsProps {
  unresolvedCommentsCount: number
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

export const ToggleCommentsButton = (props: ToggleCommentsProps): JSX.Element => {
  return (
    <IconButton
      data-testid="commentsToggleButton"
      aria-label='Toggle comments'
      onClick={props.onClick}
      sx={{ bgcolor: 'white' }}
    >
      <Textsms sx={{ color: 'var(--blue-700)' }} />
      {props.unresolvedCommentsCount > 0 &&
        <Box
          data-testid="unresolvedCommentsCount"
          sx={{
            backgroundColor: 'var(--red-500)',
            color: 'white',
            borderRadius: '50%',
            padding: '2px 6px',
            fontSize: '12px',
            position: 'absolute',
            top: '0',
            right: '-10px'
          }}
        >
          {props.unresolvedCommentsCount}
        </Box>
      }
    </IconButton>
  )
}
